import { useApolloClient } from "react-apollo"

import { useHistory } from "react-router-dom"
import * as Sentry from "@sentry/browser"

import { useSignOutMutation } from "graphql/mutations/signOut"
import { useMutationLoadingStatus } from "shared/context/mutation-loading-status"

import { baseRoutes } from "routes"

export const useSignOut = () => {
  const client = useApolloClient()
  const history = useHistory()
  const [signOutMutation, { loading }] = useSignOutMutation()
  const { setIsLoading } = useMutationLoadingStatus()

  const signOut = async () => {
    setIsLoading(true)

    try {
      const response = await signOutMutation()

      if (response.data?.signOut?.success) {
        client.resetStore()

        history.push(baseRoutes.homepage())
      }
    } catch (error) {
      Sentry.captureException(error)
    }

    setIsLoading(false)
  }

  return {
    signOut,
    loading
  }
}
